import React, { useState, useContext, useEffect, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
import Cookies from "js-cookie";
import { useSearchParams } from "react-router-dom";

import { getProviderRatingAnalytics } from "api";
import DataTable from "components/organisms/DataTable/DataTable";
import errorToast from "helpers/errorToast";
import AnalyticsContext from "../analyticsContext";

function Rating() {
  const { params } = useContext(AnalyticsContext);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [searchParams] = useSearchParams();
  const queryPage = +(searchParams.get("page") || 0);

  const columns = useMemo(
    () => [
      {
        Header: (
          <span className="pl-9 ">
            <FormattedMessage id="general.provider" defaultMessage="Provider" />
          </span>
        ),
        accessor: "provider",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <p className="pl-9 pt-8 pb-8 mb-0">{value}</p>,
      },
      {
        Header: (
          <span className="mb-0 text-right ">
            <FormattedMessage id="general.reviews" defaultMessage="Reviews" />
          </span>
        ),
        accessor: "reviews_count",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <p className="pt-8 pb-8 mb-0">{value}</p>,
      },
      {
        Header: (
          <span className="mb-0 ">
            <FormattedMessage id="general.onTimePerformance" defaultMessage="On-Time Performance" />
          </span>
        ),
        accessor: "ontime_performance_rating",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <div className="pt-8 pb-8">{value}</div>,
      },
      {
        Header: (
          <span className="mb-0 text-right ">
            <FormattedMessage id="general.communication" defaultMessage="Communication" />
          </span>
        ),
        accessor: "communication_rating",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <div className={`pt-8 pb-8 `}>{value}</div>,
      },
      {
        Header: (
          <span className="mb-0 text-right ">
            <FormattedMessage id="general.pricing" defaultMessage="Pricing" />
          </span>
        ),
        accessor: "pricing_rating",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <div className={`pt-8 pb-8 `}>{value}</div>,
      },
      {
        Header: (
          <span className="mb-0 text-right ">
            <FormattedMessage id="general.overallPerformance" defaultMessage="Overall Performance" />
          </span>
        ),
        accessor: "overall_performance",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <div className={`pt-8 pb-8 `}>{value}</div>,
      },
    ],
    [],
  );

  const instance = useTable(
    {
      initialState: {
        pageSize: +(Cookies.get("listing_sizeperpage") || 10),
        pageIndex: queryPage ? queryPage - 1 : 0,
      },
      columns,
      data,
      manualPagination: true,
      pageCount: Math.ceil(totalData / +(Cookies.get("listing_sizeperpage") || 10)),
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setIsLoading(true);
    getProviderRatingAnalytics({
      params: {
        page_size: instance.state.pageSize,
        page: instance.state.pageIndex + 1,
        ...params,
      },
    })
      .then((res) => {
        setData(res.data.results);
        setTotalData(res.data.count);
        setIsLoading(false);
      })
      .catch((err) => errorToast(err));
  }, [params, instance.state.pageSize, instance.state.pageIndex]);

  useEffect(() => {
    instance.gotoPage(queryPage ? queryPage - 1 : 0);
  }, [queryPage]);

  return (
    <div className="mt-3">
      <DataTable tableInstance={instance} totalData={totalData} isLoading={isLoading} draggable={false} />
    </div>
  );
}

export default Rating;
